import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import { HEADER_MOBILE_MEDIA_QUERY, HEADER_DESKTOP_MEDIA_QUERY } from '../../constants';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';
import { MENU_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import { clearFilter } from '../../services/filter/actions';
import { showSubNav, hideSubNav } from '../../services/nav/actions';
import { toggleMenuMobileSlide } from '../../services/header/actions';
import { getOrderedCategories } from '../../services/category/selector';

import LocalizedNavLink from '../router/LocalizedNavLink';
import CategoriesSubNavComponent from './CategoriesSubNavComponent';

import './NavComponent.scss';

class MenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOffline: false,
            isEbon: false
        };
    }

    componentDidUpdate(prevProps) {
        const { stateOpenMenuMobileSlide, versionOpenMenuMobileSlide } = this.props;

        if (
            !prevProps.stateOpenMenuMobileSlide &&
            stateOpenMenuMobileSlide &&
            versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
        ) {
            document.addEventListener('keydown', this.trapFocus, false);
            document.querySelector('#mobile-nav-menu-button-close').focus();
        }
        if (
            prevProps.versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE &&
            prevProps.stateOpenMenuMobileSlide &&
            !stateOpenMenuMobileSlide
        ) {
            document.removeEventListener('keydown', this.trapFocus, false);
            document.querySelector('#menu-mobile-bt').focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.trapFocus, false);
    }

    trapFocus = e => {
        const focusableElements = 'button, a, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#menu'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    };

    toggleOffline = value => {
        this.setState({ isOffline: value });
    };
    toggleEbon = value => {
        this.setState({ isEbon: value });
    };

    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    showCategories = (isOffline, isEbon) => () => {
        this.toggleOffline(isOffline);
        this.toggleEbon(isEbon);
        this.onMouseEnterCategories();
    };

    // Ferme le sous-menu quand le focus quitte le groupe lien + sous-menu.
    // Tant que le focus reste à l'intérieur d'un sous-menu, on garde ouvert.
    handleSubNavBlur = e => {
        const next = e.relatedTarget;
        if (next && next.closest && next.closest('.sous-menu-rubriques')) {
            return;
        }
        this.hideSubNav();
    };

    // Escape ferme le sous-menu ouvert et rend le focus au lien déclencheur.
    handleSubNavKeyDown = e => {
        if (e.key === 'Escape' && this.props.subNavDisplayed) {
            this.hideSubNav();
            const triggerId = this.state.isEbon ? 'nav-link-ebon' : 'nav-link-online';
            const trigger = document.getElementById(triggerId);
            if (trigger) {
                trigger.focus();
            }
        }
    };

    onClickBtMenuMobile = e => {
        e.preventDefault();
        this.props.toggleMenuMobileSlide(MENU_VERSION_MENU_MOBILE_SLIDE);
    };

    render() {
        const {
            i18n,
            i18nAccessibility,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            categories,
            location,
            subNavDisplayed
        } = this.props;
        const { isOffline, isEbon } = this.state;
        const OnlineDirectoryUrl = `/${PATH.ONLINE}/`;
        const EbonDirectoryUrl = `/${PATH.EBON}/`;
        const ReductionDirectoryUrl = `${PATH.REDUCTION_PATH}/`;
        const resetFilter = () => {
            this.props.clearFilter('directory');
        };
        return (
            <nav
                id="menu"
                className={`menu menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : 'closed'
                }`}
                role={stateOpenMenuMobileSlide ? 'dialog' : 'navigation'}
                aria-label={stateOpenMenuMobileSlide ? i18nAccessibility.MODAL_LABEL_MEMBER : ''}
                aria-modal={stateOpenMenuMobileSlide ? 'true' : 'false'}>
                <div className="menu-mobile-slide-titre bold flex-container-h flex-center-alt">
                    {i18n.TITLE}
                    <button
                        id="mobile-nav-menu-button-close"
                        className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                            stateOpenMenuMobileSlide ? 'open' : 'closed'
                        }`}
                        data-target="menu"
                        onClick={this.onClickBtMenuMobile.bind(this)}>
                        <span />
                        <span className="sr-only">{i18nAccessibility.NAV_MENU_BUTTON_CLOSE}</span>
                    </button>
                </div>
                <div
                    className="conteneur menu-conteneur flex-container-h"
                    onClick={resetFilter}
                    onBlur={this.handleSubNavBlur}
                    onKeyDown={this.handleSubNavKeyDown}>
                    <LocalizedNavLink
                        id="nav-link-home"
                        to={PATH.HOME_PATH}
                        title={i18n.HOME}
                        activeClassName="actif"
                        exact>
                        {i18n.HOME}
                    </LocalizedNavLink>
                    <LocalizedNavLink
                        to={PATH.HOW_IT_WORK_PATH}
                        title={i18n.HOW_IT_WORKS}
                        activeClassName="actif">
                        {i18n.HOW_IT_WORKS}
                    </LocalizedNavLink>

                    {/* Offres en ligne : le lien reste affiché sur tous les viewports */}
                    <LocalizedNavLink
                        id="nav-link-online"
                        to={PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH}
                        title={i18n.ONLINE_OFFERS}
                        className={`menu-sous-menu ${
                            location.pathname.indexOf(OnlineDirectoryUrl) !== -1 ? 'actif' : ''
                        }`}
                        aria-haspopup="true"
                        aria-expanded={subNavDisplayed && !isEbon}
                        aria-controls="sous-menu-rubriques-online"
                        onMouseEnter={this.showCategories(false, false)}
                        onMouseLeave={this.onMouseLeaveCategories}
                        onFocus={this.showCategories(false, false)}>
                        {i18n.ONLINE_OFFERS}
                    </LocalizedNavLink>
                    <MediaQuery query={HEADER_DESKTOP_MEDIA_QUERY}>
                        {matches =>
                            matches && (
                                <CategoriesSubNavComponent
                                    categories={categories}
                                    id="sous-menu-rubriques-online"
                                    open={subNavDisplayed && !isEbon}
                                    ariaLabel={i18nAccessibility.NAV_SUBMENU_ONLINE_LABEL}
                                />
                            )
                        }
                    </MediaQuery>
                    <MediaQuery query={HEADER_MOBILE_MEDIA_QUERY}>
                        {matches =>
                            matches &&
                            !isOffline &&
                            !isEbon && (
                                <CategoriesSubNavComponent
                                    categories={categories}
                                    id="sous-menu-rubriques-online"
                                    ariaLabel={i18nAccessibility.NAV_SUBMENU_ONLINE_LABEL}
                                />
                            )
                        }
                    </MediaQuery>

                    {/* Offres en bon d'achat : le lien reste affiché sur tous les viewports */}
                    <LocalizedNavLink
                        id="nav-link-ebon"
                        to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                        title={i18n.EBON_OFFERS}
                        className={`menu-sous-menu ${
                            location.pathname.indexOf(EbonDirectoryUrl) !== -1 ? 'actif' : ''
                        }`}
                        aria-haspopup="true"
                        aria-expanded={subNavDisplayed && isEbon}
                        aria-controls="sous-menu-rubriques-ebon"
                        onMouseEnter={this.showCategories(false, true)}
                        onMouseLeave={this.onMouseLeaveCategories}
                        onFocus={this.showCategories(false, true)}>
                        {i18n.EBON_OFFERS}
                    </LocalizedNavLink>
                    <MediaQuery query={HEADER_DESKTOP_MEDIA_QUERY}>
                        {matches =>
                            matches && (
                                <CategoriesSubNavComponent
                                    categories={categories}
                                    id="sous-menu-rubriques-ebon"
                                    open={subNavDisplayed && isEbon}
                                    ariaLabel={i18nAccessibility.NAV_SUBMENU_EBON_LABEL}
                                    isEbon
                                />
                            )
                        }
                    </MediaQuery>
                    <MediaQuery query={HEADER_MOBILE_MEDIA_QUERY}>
                        {matches =>
                            matches &&
                            isEbon && (
                                <CategoriesSubNavComponent
                                    categories={categories}
                                    id="sous-menu-rubriques-ebon"
                                    ariaLabel={i18nAccessibility.NAV_SUBMENU_EBON_LABEL}
                                    isEbon
                                />
                            )
                        }
                    </MediaQuery>

                    <LocalizedNavLink
                        id="nav-link-reduction"
                        to={PATH.REDUCTION_MOST_POPULAR_PATH}
                        title={i18n.REDUCTION}
                        className={
                            location.pathname.indexOf(ReductionDirectoryUrl) !== -1 ? 'actif' : ''
                        }>
                        {i18n.REDUCTION}
                    </LocalizedNavLink>

                    <LocalizedNavLink
                        to={PATH.CONTACTREQUEST_PATH}
                        title={i18n.CONTACT}
                        activeClassName="actif">
                        {i18n.CONTACT}
                    </LocalizedNavLink>
                </div>
            </nav>
        );
    }
}

MenuComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        i18n: state.i18n.feature.header.menu,
        i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY,
        categories: getOrderedCategories(state),
        subNavDisplayed: !!state.nav.subNav,
        location: state.routing.location
    };
};

const mapDispatchToProps = {
    clearFilter,
    showSubNav,
    hideSubNav,
    toggleMenuMobileSlide
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/NavComponent.js